const MeetingLink = () => {
  return <div>MeetingLink</div>;
};

export default MeetingLink;
